import React, {useState} from "react"
import {findDOMNode} from "react-dom"

import UI5CalendarRange from "../../../../../../gd-components/datetime/calendar-v2/calendar-range"
import Popover from "../../../../../../gd-components/gd-popover/popover"

const debug = false
// const debug = "FieldDateDue_Popover"

export default function FieldDateDue_Popover(props:any) {
    debug && console.log(debug, 'render', props)

    const [showStartDate, setShowStartDate] = useState(!!props.parent.state.currentValue?.start)

    const addStartDate = () => {
        setShowStartDate(true)
    }

    const onSelect = (dateRange:any) => {
        debug && console.log(debug, 'onSelect', dateRange)

        props.parent.hidePopover()

        if (showStartDate) {
            props.parent.onValueChange(dateRange)
        } else {
            props.parent.onValueChange(_.pick(dateRange, ['end']))
        }
    }

    const leftRenderComponent = (props:any) => {
        debug && console.log(debug, 'leftRenderComponent', props)

        return (
            <div className="flex-row-center-center flex-1 h-100-percent">
                <div className="ui5-txt-link" onClick={addStartDate}>
                    <div className="ui5-ico-14 i5-calendar link m-r-8"/>
                    Add start date
                </div>
            </div>
        )
    }

    debug && console.log(debug, 'render', props.parent.state.currentValue)

    return (
        <Popover className          = "daterange-picker-popover" attachment="top center"
                 targetAttachment   = "bottom center"
                 getTargetFunc      = {()=>findDOMNode(props.parent)}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}>

            <div className="flex-row-center-center h-24 m-t-20">
                <div className="flex-row-center-center ui5-title-small w-100-percent">Start Date</div>
                <div className="flex-row-center-center ui5-title-small w-100-percent">Due Date</div>
            </div>

            <UI5CalendarRange selectedRange         = {props.parent.state.currentValue}
                              minDate               = {props.field.minDate}
                              maxDate               = {props.field.maxDate}
                              presets               = {false}
                              singleDateSelection   = {!showStartDate}
                              leftRenderComponent   = {showStartDate ? null : leftRenderComponent}
                              onSelect              = {onSelect}/>
        </Popover>
    );
}